import type {
  WrapupDraftInput,
  WrapupDraftView,
  WrapupPreview,
  WrapupSendResult,
} from '@gwc/shared';
import { api } from '../lib/api';

/** The post-tasting wrap-up email (`/events/:id/wrapup`, comms:event). */
export const wrapupApi = {
  draft: (eventId: string) =>
    api.get<{ data: WrapupDraftView }>(`/events/${eventId}/wrapup`).then((r) => r.data),
  save: (eventId: string, input: WrapupDraftInput) =>
    api.put<{ data: WrapupDraftView }>(`/events/${eventId}/wrapup`, input).then((r) => r.data),
  /** Render as `personId` would receive it (default: you). */
  preview: (eventId: string, personId?: string) =>
    api
      .post<{ data: WrapupPreview }>(
        `/events/${eventId}/wrapup/preview`,
        personId ? { personId } : {},
      )
      .then((r) => r.data),
  send: (eventId: string, test: boolean) =>
    api
      .post<{ data: WrapupSendResult }>(`/events/${eventId}/wrapup/send`, { test })
      .then((r) => r.data),
};
